export default __webpack_public_path__ + "static/media/sticker-Q.2a688fe8.png";